module.exports = __webpack_public_path__ + "img/2.7314ef21.png";